import clientInfo from 'common/lib/clientInfo';
import { useCallback } from 'react';
import { trackProductAnalytics } from 'common/services/product_analytics';
import { PromptFormValuesType } from 'common/components/CopyMagic/CopyMagic.types';

const useTrackOnGenerate = () => {
  const trackCallback = useCallback(({ promptValues }: { promptValues: PromptFormValuesType }) => {
    trackProductAnalytics('Course Outline Prompt Sent', {
      'Site ID': clientInfo.get('site_id'),
      'Input String': promptValues.topic,
    });
  }, []);

  return trackCallback;
};

export default useTrackOnGenerate;
